import type { Components, Theme } from '@mui/material/styles';

export default function MuiFormLabel(theme: Theme): Components['MuiFormLabel'] {
  return {
    styleOverrides: {
      asterisk: {
        color: theme.palette.error.main,
        paddingLeft: '0.25rem',
        whiteSpace: 'nowrap',
      },
      root: {
        whiteSpace: 'break-spaces',
        '&.Mui-disabled': {
          color: theme.palette.taiga.main,
        },
      },
    },
  };
}
